console.log("bundle is connected");

import jQuery from "jquery";
window.$ = window.jQuery = jQuery;

import Swiper from 'swiper';
import Navigation from 'swiper/modules/navigation.min.mjs';
import Pagination from 'swiper/modules/pagination.min.mjs';

window.Swiper = Swiper;
window.Navigation = Navigation;
window.Pagination = Pagination;

import dragScroll from 'dragscroll/dragscroll';
window.dragScroll = dragScroll;